import { gql } from '@apollo/client';

const RMA_TICKET_COUNT_QUERY = gql`
  query RmaTicketCount($filter: RmaTicketsFilterInput) {
    RmaTicketCount(filter: $filter)
  }
`;

export default RMA_TICKET_COUNT_QUERY;
